var React = require('react');

function UserMinus (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M640 224v32a16 16 0 0 1-16 16H432a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M313.6 288h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48v-41.6A134.43 134.43 0 0 0 313.6 288zM224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128z","className":"fa-primary","key":2})]);
}

UserMinus.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = UserMinus;

UserMinus.default = UserMinus;
